import { render } from "./DashboardVietBaiUser.vue?vue&type=template&id=606c5d05&scoped=true"
import script from "./DashboardVietBaiUser.vue?vue&type=script&lang=js"
export * from "./DashboardVietBaiUser.vue?vue&type=script&lang=js"

import "./DashboardVietBaiUser.vue?vue&type=style&index=0&id=606c5d05&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-606c5d05"]])

export default __exports__